(function(exports){
  // Change product quantities
  function incrementQty(el) {
    el.parentNode.querySelector('._quantity').value++;
  }
  exports.incrementQty = incrementQty;

  function decrementQty(el, minValue = 1) {
    if (el.parentNode.querySelector('._quantity').value > minValue)
      el.parentNode.querySelector('._quantity').value--;
  }
  exports.decrementQty = decrementQty;

  function addVariantToCart(variantId, qty, onSuccess, onFail, onAlways) {
    return $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: {
        quantity: qty,
        id: variantId
      },
      success: onSuccess
    }).fail(onFail).always(onAlways);
  }
  exports.addVariantToCart = addVariantToCart;

  function changeCartItemQty(variantId, qty, onSuccess, onFail, onAlways) {
    // Formats the variantId into a JSON readable format compatible with the
    // Shopify update query structure.
    var data = {};
    if (data.updates === undefined) data.updates = {};
    data.updates[variantId] = qty;

    return $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      type: 'post',
      data: data,
      success: onSuccess
    }).fail(onFail).always(onAlways);
  }
  exports.changeCartItemQty = changeCartItemQty;
})(window);
